<template>
  <b-row class="justify-content-center my-5">
    <b-col cols="10" lg="6" class="sg-rounded-container">
      <b-row class="text-center">
        <b-col class="p-5">
          <b-img
            :src="require('@/assets/img/customer/happy-traveling.png')"
            fluid
          />
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="10">
          <h4>What's Next?</h4>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="10">
          <h6>
            Kami sudah mengirimkan email cara pembayaran melalui transfer. Silahkan buka email anda untuk menyelesaikan pembayaran.
          </h6>
        </b-col>
      </b-row>

      <b-row class="mt-3" />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Pay_Pending'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Pay/Pending.vue